import React, { useMemo } from "react";

export const visitorFieldNames = [
    "sop_referrerurl",
    "sop_landingpage",
    "sop_utmsource",
    "sop_utmcampaign",
    "sop_utmmedium",
    "sop_utmcontent",
    "sop_leadchannel",
];

const StaticVisitorFields = () => {
    const fields = useMemo(
        () =>
            visitorFieldNames.map((name) => (
                <input
                    key={name}
                    type="hidden"
                    name={name}
                    className="dynamics-hidden-field"
                />
            )),
        [],
    );

    return <>{fields}</>;
};

export default React.memo(StaticVisitorFields);
